module.exports = __webpack_public_path__ + "img/6.a8e18562.jpg";